/**
 * プライバシーポリシーチェックボックスの状態に応じて
 * 送信ボタンを半透明にする
 */
function syncPrivacyState(form: Element): void {
  const checkbox = form.querySelector('input[type="checkbox"][name="privacy-policy[]"]') as HTMLInputElement | null;

  if (checkbox) {
    // 入力ステップ: チェック有無をフォームに反映
    form.classList.toggle('--privacy-unchecked', !checkbox.checked);
  } else {
    // 確認・完了ステップ: チェックボックスが無い = 通過済み
    form.classList.remove('--privacy-unchecked');
  }
}

function initPrivacyCheckbox(): void {
  const isContactPage =
    document.body.classList.contains('page-contact') ||
    document.body.classList.contains('page-recruit-contact') ||
    window.location.pathname.includes('contact');

  if (!isContactPage) return;

  const forms = document.querySelectorAll<Element>('.snow-monkey-form');
  forms.forEach((form) => {
    // 初期状態を反映
    syncPrivacyState(form);

    // イベントデリゲーションでチェックボックスの変化を検知
    form.addEventListener('change', (e: Event) => {
      const target = e.target as HTMLElement;
      if (target instanceof HTMLInputElement && target.name === 'privacy-policy[]') {
        syncPrivacyState(form);
      }
    });

    // フォームのステップ切り替え（DOM差し替え）を監視
    const observer = new MutationObserver(() => {
      syncPrivacyState(form);
    });

    observer.observe(form, { childList: true, subtree: true });
  });
}

export function smfPrivacyCheckbox(): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrivacyCheckbox);
  } else {
    initPrivacyCheckbox();
  }
}
